import { getUserInfo } from "@/lib/api/client-authentication";
import { useForm } from "react-hook-form";

// import { getUser } from "@/lib/api/authentication";


type AwardFormSubmit = {
    award: string;
}

type FormProps = {
    id: string,
    onUpdate: any
    awardDetails?: any
}

export const AwardForm = ({ id, onUpdate, awardDetails }: FormProps) => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm<AwardFormSubmit>({
        defaultValues: {
            award: awardDetails?.awardName
        }
    });

    const resetForm = () => {
        reset();
    };

    const onSubmit = async (data: AwardFormSubmit) => {
        const user = await getUserInfo();

        const award = {
            name: data['award']
        };

        if (awardDetails !== undefined) {
            onUpdate(id, { index: awardDetails?.index, award }, "edit")
        } else {
            onUpdate(id, award, "new")

        }

        resetForm()


    }

    return (
        <div className="profile-add">
            <div className="row">
                <div className="col-md-10 offset-sm-1">
                    <h1 className="text-lg font-bold underline">Awards</h1><br />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-row mb-2">
                            <div className="flex flex-col">
                                <label className="text-base font-bold">Award :</label>
                                <input type="text" {...register('award')} className="text-base border-black border  border-solid rounded-sm pl-1" name="award" />
                            </div>
                        </div>
                        <br />
                        <div className="form-row">
                            <div className="col-md-12 text-center">
                                <button type="submit" className="btn btn-primary btn-save">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}